// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/companies/:company_id/free_trial/developers_table" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdFreeTrialDevelopersTable } from "./constants";
import type { CompaniesCompanyIdFreeTrialDevelopersTableParams, FreeTrialDevelopersTableResult } from "./types";

export const getFreeTrialDevelopersTable = reactQueryTableFetcherAdapter(
  companiesCompanyIdFreeTrialDevelopersTable,
  (
    signal: AbortSignal,
    {
      companyId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      excludeImpersonationAccounts = true,
      reducedData,
    }: CompaniesCompanyIdFreeTrialDevelopersTableParams
  ): Promise<FreeTrialDevelopersTableResult> => {
    return fetch(
      `/companies/${companyId}/free_trial/developers_table`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        exclude_impersonation_accounts: excludeImpersonationAccounts,
        reduced_data: reducedData,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
